import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionEditActions from './SectionEditActions';
import ProjectKickoffTab from './ProjectKickoffTab';
import MallDecorationTab from './MallDecorationTab';
import BiddingSupportTab from './BiddingSupportTab';
import CustomDesignTab from './CustomDesignTab';
import QuotationTab from './QuotationTab';
import BidOpeningDeliverySection from './BidOpeningDeliverySection';
import { buildDisabledTaskPrefixes, findCustomerName } from './utils/form';

// 各任务子组件的字段级校验通过 inject['elForm'] 调用：
// element-ui 的 el-form 自身会 provide('elForm', this)，无需在此重复 provide
export default {
  name: 'ApplyInfoPanel',
  components: {
    SectionEditActions: SectionEditActions,
    ProjectKickoffTab: ProjectKickoffTab,
    MallDecorationTab: MallDecorationTab,
    BiddingSupportTab: BiddingSupportTab,
    CustomDesignTab: CustomDesignTab,
    QuotationTab: QuotationTab,
    BidOpeningDeliverySection: BidOpeningDeliverySection
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    rules: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'add'
    },
    id: {
      type: [String, Number],
      default: ''
    },
    projectStatus: {
      type: [String, Number],
      default: null
    },
    editSaving: {
      type: Boolean,
      default: false
    },
    companyList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    opportunityList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    leaderOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    decorationPersonList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cardDesignPersonList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bidSupportPersonList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cardTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    quotationCardTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    businessTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    quotationBusinessTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    initialTypes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inputName: {
      type: String,
      default: ''
    },
    isApproveOtherDemand: {
      type: Boolean,
      default: false
    },
    quotationCheckboxDisabled: {
      type: Boolean,
      default: false
    },
    quotationCheckboxLabel: {
      type: String,
      default: '报价单'
    },
    showCardTypeField: {
      type: Boolean,
      default: false
    },
    hadInitialDesignDraft: {
      type: Boolean,
      default: false
    },
    getCompanyList: {
      type: Function,
      required: true
    },
    changeCustomer: {
      type: Function,
      required: true
    },
    changeOpportunity: {
      type: Function,
      required: true
    },
    changeProject: {
      type: Function,
      required: true
    },
    shouldShowTaskType: {
      type: Function,
      required: true
    },
    isTaskFormDisabled: {
      type: Function,
      required: true
    },
    isEditingTask: {
      type: Function,
      required: true
    },
    isViewTaskDisabled: {
      type: Function,
      required: true
    },
    showProjectInfoEditButton: {
      type: Function,
      required: true
    },
    startProjectInfoEdit: {
      type: Function,
      required: true
    },
    confirmProjectInfoEdit: {
      type: Function,
      required: true
    },
    cancelProjectInfoEdit: {
      type: Function,
      required: true
    },
    changeOrderBusinessType: {
      type: Function,
      required: true
    },
    changeQuotationBusinessType: {
      type: Function,
      required: true
    }
  },
  data: function data() {
    return {
      activeTaskTab: '1',
      lastInvalidProps: []
    };
  },
  computed: {
    visibleTaskTabNames: function visibleTaskTabNames() {
      var _this = this;
      return ['1', '2', '3', '9'].filter(function (taskType) {
        return _this.taskTabVisible(taskType);
      });
    },
    // 启动会项目的「项目启动会信息」tab：审批态且挂了报价单任务时审批对象是报价单，不展示
    showKickoffTab: function showKickoffTab() {
      return this.formData.project_type === '1' && !(this.type === 'approve' && this.formData.type.includes('9'));
    },
    customerName: function customerName() {
      return findCustomerName(this.companyList, this.formData.customer_id);
    }
  },
  watch: {
    // 切换任务 tab 后把滚动位置对齐到 tab 栏，避免新面板顶部被滚过
    activeTaskTab: function activeTaskTab() {
      this.scrollTaskTabsIntoView();
    },
    // 激活 tab 对应的任务被取消勾选时，回落到第一个可见 tab
    visibleTaskTabNames: {
      immediate: true,
      handler: function handler(names) {
        if (this.showKickoffTab) {
          this.activeTaskTab = 'kickoff';
          return;
        }
        if (!names.includes(this.activeTaskTab)) {
          this.activeTaskTab = names[0] || '1';
        }
      }
    },
    // 项目类型切换时同步任务 tab：启动会固定落在 kickoff
    'formData.project_type': function formDataProject_type(val) {
      if (val === '1' && this.showKickoffTab) {
        this.activeTaskTab = 'kickoff';
      } else if (this.activeTaskTab === 'kickoff') {
        this.activeTaskTab = this.visibleTaskTabNames[0] || '1';
      }
    }
  },
  methods: {
    // 任务 tab 是否可见，条件与对应任务区块的渲染条件一致
    taskTabVisible: function taskTabVisible(taskType) {
      return String(this.formData.project_type) == 2 && this.formData.type.includes(taskType) || this.formData.project_meeting && this.formData.project_meeting.process_result === '1' && this.formData.type.includes(taskType);
    },
    // 提交校验失败时，切换到首个含出错字段的任务 tab，避免错误藏在未激活面板里
    // 将滚动容器的位置对齐到 tab 栏顶部，已滚过 tab 栏时才回调
    scrollTaskTabsIntoView: function scrollTaskTabsIntoView() {
      var _this2 = this;
      this.$nextTick(function () {
        var container = _this2.$el.closest('.applyFormContent');
        var tabs = _this2.$refs.taskTabs;
        if (!container || !tabs) return;
        // 留 16px 余量，避免回弹后吸顶栏贴住面板标题
        var target = tabs.$el.getBoundingClientRect().top - container.getBoundingClientRect().top + container.scrollTop - 16;
        if (container.scrollTop > target) {
          container.scrollTop = Math.max(target, 0);
        }
      });
    },
    getDisabledTaskPrefixes: function getDisabledTaskPrefixes() {
      return buildDisabledTaskPrefixes(this.isTaskFormDisabled);
    },
    focusTaskTabWithError: function focusTaskTabWithError() {
      var prefixToTab = [{
        prefix: 'items.mall_decoration',
        tab: '1'
      }, {
        prefix: 'items.bidding_support',
        tab: '2'
      }, {
        prefix: 'items.card_and_coupon_design',
        tab: '3'
      }, {
        prefix: 'items.quotation',
        tab: '9'
      }];
      var disabledPrefixes = this.getDisabledTaskPrefixes();
      var prop = (this.lastInvalidProps || []).find(function (p) {
        return !disabledPrefixes.some(function (dp) {
          return p === dp || p.startsWith(dp);
        }) && prefixToTab.some(function (m) {
          return p === m.prefix || p.startsWith(m.prefix);
        });
      });
      if (!prop) return;
      var match = prefixToTab.find(function (m) {
        return prop === m.prefix || prop.startsWith(m.prefix);
      });
      if (match && this.taskTabVisible(match.tab)) {
        this.activeTaskTab = match.tab;
      }
      this.scrollTaskTabsIntoView();
    },
    // 按前缀限定校验范围的表单校验，返回 Promise<boolean>
    // only：仅该前缀集合内字段的错误才拦截；except：排除该前缀集合字段后其余错误拦截
    // 仅依赖 el-form 公开的 validate/clearValidate，不再读取内部 form.fields
    validateScoped: function validateScoped() {
      var _this3 = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$only = _ref.only,
        only = _ref$only === void 0 ? null : _ref$only,
        _ref$except = _ref.except,
        except = _ref$except === void 0 ? [] : _ref$except;
      return new Promise(function (resolve) {
        _this3.$refs.form.validate(function (valid, invalidFields) {
          var failedProps = Object.keys(invalidFields || {});
          _this3.lastInvalidProps = failedProps;
          var inScope = function inScope(prop) {
            return only !== null ? only.some(function (prefix) {
              return prop === prefix || prop.startsWith(prefix);
            }) : !except.some(function (prefix) {
              return prop === prefix || prop.startsWith(prefix);
            });
          };
          var outOfScopeProps = failedProps.filter(function (prop) {
            return !inScope(prop);
          });
          if (outOfScopeProps.length) {
            _this3.$nextTick(function () {
              _this3.$refs.form && _this3.$refs.form.clearValidate(outOfScopeProps);
            });
          }
          resolve(valid || failedProps.every(function (prop) {
            return !inScope(prop);
          }));
        });
      });
    },
    clearValidate: function clearValidate(props) {
      return this.$refs.form && this.$refs.form.clearValidate(props);
    },
    validateField: function validateField(props) {
      return this.$refs.form && this.$refs.form.validateField(props);
    },
    // 查看/禁用态允许选中复制，但拦截下拉、日期、单选、复选、数字步进器的交互
    handleReadonlyClick: function handleReadonlyClick(event) {
      var target = event.target;
      var disabledRoot = target.closest('.view-form-disabled, .sub-form-disabled');
      if (!disabledRoot) return;
      if (target.closest('.sub-form-editing, .demand-info-editing')) return;
      if (target.closest('.el-select, .el-date-editor, .el-radio, .el-checkbox, .el-input-number')) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    // filterable 下拉框和日期选择器在 focus 时即展开面板，
    // 关闭面板但保留焦点，保证查看态仍可选中复制文本
    handleReadonlyFocusin: function handleReadonlyFocusin(event) {
      var _this4 = this;
      var target = event.target;
      var disabledRoot = target.closest('.view-form-disabled, .sub-form-disabled');
      if (!disabledRoot) return;
      if (target.closest('.sub-form-editing, .demand-info-editing')) return;
      this.closeReadonlyPopups(target);
      this.$nextTick(function () {
        return _this4.closeReadonlyPopups(target);
      });
    },
    closeReadonlyPopups: function closeReadonlyPopups(target) {
      this.closeReadonlyPopup(target, '.el-select', 'visible');
      this.closeReadonlyPopup(target, '.el-date-editor', 'pickerVisible');
    },
    closeReadonlyPopup: function closeReadonlyPopup(target, selector, key) {
      var el = target.closest(selector);
      var vm = el && el.__vue__;
      for (var i = 0; vm && i < 2; i++) {
        if (!(key in vm)) {
          vm = vm.$parent;
          continue;
        }
        if (vm[key]) vm[key] = false;
        if (key === 'visible') vm.menuVisibleOnFocus = false;
        return;
      }
    },
    handleReadonlyKeydown: function handleReadonlyKeydown(event) {
      var target = event.target;
      var disabledRoot = target.closest('.view-form-disabled, .sub-form-disabled');
      if (!disabledRoot) return;
      if (target.closest('.sub-form-editing, .demand-info-editing')) return;
      var isCopy = (event.ctrlKey || event.metaKey) && ['c', 'a'].includes(event.key.toLowerCase());
      if (isCopy) return;
      if (target.closest('input, textarea')) event.preventDefault();
    }
  }
};